<div class="modal-header py-2" *ngIf="!embedded">
  <div>
    <h5 class="modal-title mb-0">{{ isEdit ? 'Kimlik Tespiti Kaydını Düzenle' : 'Yeni Kimlik Tespiti Kaydı' }}</h5>
    <div class="kyc-hint" *ngIf="thresholdAmountTl">
      {{ thresholdAmountTl | number: '1.2-2' }} TL ve üzeri işlemlerde kimlik tespiti zorunludur.
    </div>
  </div>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div [class.modal-body]="!embedded" *ngIf="!loading; else loadingTpl">

  <!-- ── 1. Kimlik belgesi: fotoğraflar seçilince T.C. Kimlik Kartı okunup forma yazılır (masak-kimlik-ocr.md).
       Görsel tarayıcıda okunur, dışarı gönderilmez. ───────────────────────────────────────────────── -->
  <div class="kyc-section">
    <i class="mdi mdi-card-account-details-outline"></i>{{ isCompany ? 'Yetkilinin Kimlik Belgesi' : 'Kimlik Belgesi' }}
    <span class="kyc-section-aside">Fotoğraf ya da PDF</span>
  </div>
  <div class="row g-2">
    <div class="col-md-4">
      <label class="form-label">Belge Türü{{ isCompany ? ' *' : '' }}</label>
      <select class="form-select form-select-sm" [(ngModel)]="request.documentType" name="documentType"
        (ngModelChange)="onDocumentTypeChange()">
        <option *ngFor="let o of documentTypeOptions" [ngValue]="o.value">{{ o.text }}</option>
      </select>
    </div>
    <ng-container *ngIf="isTckn; else singleFileTpl">
      <div class="col-6 col-md-4">
        <label class="form-label">Ön Yüz</label>
        <label class="file-pick" [class.has-file]="documentFrontFile" title="Kimlik kartının ön yüzü">
          <input type="file" class="d-none" accept="image/*,application/pdf" #frontFileInput (change)="onFrontFileSelected($event)">
          <i class="mdi" [ngClass]="documentFrontFile ? 'mdi-check-circle text-success' : 'mdi-camera-outline'"></i>
          <span class="file-pick-name">{{ documentFrontFile?.name || (existingDocumentUrl ? 'Yüklü — değiştir' : 'Ön yüzü seçin') }}</span>
          <i class="mdi mdi-close text-muted" *ngIf="documentFrontFile" title="Kaldır"
            (click)="$event.preventDefault(); $event.stopPropagation(); removeIdentityFile('front')"></i>
        </label>
      </div>
      <div class="col-6 col-md-4">
        <label class="form-label">Arka Yüz</label>
        <label class="file-pick" [class.has-file]="documentBackFile" title="Kimlik kartının arka yüzü (MRZ)">
          <input type="file" class="d-none" accept="image/*,application/pdf" #backFileInput (change)="onBackFileSelected($event)">
          <i class="mdi" [ngClass]="documentBackFile ? 'mdi-check-circle text-success' : 'mdi-camera-outline'"></i>
          <span class="file-pick-name">{{ documentBackFile?.name || (existingDocumentBackUrl ? 'Yüklü — değiştir' : 'Arka yüzü seçin') }}</span>
          <i class="mdi mdi-close text-muted" *ngIf="documentBackFile" title="Kaldır"
            (click)="$event.preventDefault(); $event.stopPropagation(); removeIdentityFile('back')"></i>
        </label>
      </div>
    </ng-container>
    <ng-template #singleFileTpl>
      <div class="col-md-8">
        <label class="form-label">{{ isPassport ? 'Fotoğraflı Sayfa' : 'Belge' }}</label>
        <label class="file-pick" [class.has-file]="documentFrontFile">
          <input type="file" class="d-none" accept="image/*,application/pdf" #singleFileInput (change)="onFrontFileSelected($event)">
          <i class="mdi" [ngClass]="documentFrontFile ? 'mdi-check-circle text-success' : 'mdi-file-upload-outline'"></i>
          <span class="file-pick-name">{{ documentFrontFile?.name || (existingDocumentUrl ? 'Yüklü — değiştir' : (isPassport ? 'Pasaportun fotoğraflı sayfasını seçin' : 'Belgeyi seçin')) }}</span>
          <i class="mdi mdi-close text-muted" *ngIf="documentFrontFile" title="Kaldır"
            (click)="$event.preventDefault(); $event.stopPropagation(); removeIdentityFile('front')"></i>
        </label>
      </div>
    </ng-template>
  </div>

  <!-- Kimlikten okuma (OCR) — T.C. Kimlik Kartı (iki yüz) ve pasaport (fotoğraflı sayfa). -->
  <div class="mt-2" *ngIf="ocrEnabled">
    <div class="d-flex align-items-center gap-2 kyc-hint" *ngIf="ocrReading">
      <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
      <span>{{ ocrStep }}</span>
      <div class="progress flex-grow-1" style="height: 4px; max-width: 200px;">
        <div class="progress-bar" role="progressbar" [style.width.%]="ocrProgress * 100"></div>
      </div>
      <a href="javascript:void(0)" class="ms-auto" (click)="cancelOcr()">İptal</a>
    </div>

    <div class="kyc-hint" *ngIf="!ocrReading && !ocrResult && !ocrError">
      <i class="mdi mdi-information-outline me-1"></i>
      <ng-container *ngIf="hasUnsupportedDocumentFile; else ocrIdleTpl">PDF'ten okuma desteklenmiyor — kartın fotoğrafını seçin.</ng-container>
      <ng-template #ocrIdleTpl>
        <ng-container [ngSwitch]="ocrMissingSide">
          <ng-container *ngSwitchCase="'back'">Okuma için kartın <b>arka yüzünü</b> de seçin.</ng-container>
          <ng-container *ngSwitchCase="'front'">Okuma için kartın <b>ön yüzünü</b> de seçin.</ng-container>
          <ng-container *ngSwitchDefault>
            <ng-container *ngIf="isPassport; else cardIdleTpl">Pasaportun fotoğraflı sayfası seçilince bilgiler okunup forma yazılır. Sayfayı düz, parlamasız ve alttaki iki MRZ satırı tam görünecek biçimde çekin.</ng-container>
            <ng-template #cardIdleTpl>Kartın ön ve arka yüz fotoğrafı seçilince bilgiler okunup forma yazılır. Kartı düz, parlamasız ve kenarları görünür çekin.</ng-template>
          </ng-container>
        </ng-container>
      </ng-template>
      <a href="javascript:void(0)" class="ms-1" *ngIf="canReadOcr" (click)="readIdentity()">Kimlikten oku</a>
    </div>

    <div class="alert alert-danger d-flex flex-wrap align-items-center gap-2 py-1 px-2 small mb-0" *ngIf="ocrError && !ocrReading">
      <span class="flex-grow-1">{{ ocrError }}</span>
      <button type="button" class="btn btn-sm btn-link p-0" *ngIf="ocrCropSide" (click)="cropAndRead()">
        <i class="mdi mdi-crop me-1"></i>Kartı Kırp
      </button>
      <button type="button" class="btn btn-sm btn-link p-0" [disabled]="!canReadOcr" (click)="readIdentity()">
        <i class="mdi mdi-refresh me-1"></i>Yeniden Oku
      </button>
    </div>

    <ng-container *ngIf="ocrResult && !ocrReading">
      <div class="d-flex flex-wrap align-items-center gap-1">
        <span class="kyc-hint me-1"><i class="mdi mdi-text-recognition me-1"></i>Kimlikten okundu:</span>
        <span class="ocr-chip" *ngFor="let row of ocrRows; trackBy: trackOcrRow" [ngClass]="row.status"
          [title]="ocrStatusText(row.status) + (row.value ? ' — ' + row.value : '')">
          <i class="mdi" [ngClass]="ocrStatusIcon(row.status)"></i>{{ row.label }}
        </span>
        <span class="ms-auto d-flex gap-2">
          <button type="button" class="btn btn-sm btn-link p-0" *ngIf="ocrCropSide" (click)="cropAndRead()">
            <i class="mdi mdi-crop me-1"></i>Kırp
          </button>
          <button type="button" class="btn btn-sm btn-link p-0" [disabled]="!canReadOcr" (click)="readIdentity()">
            <i class="mdi mdi-refresh me-1"></i>Yeniden Oku
          </button>
        </span>
      </div>

      <div class="alert d-flex flex-wrap align-items-center gap-2 py-1 px-2 small mt-2 mb-0" *ngIf="ocrNameMismatch"
        [ngClass]="ocrNameMismatchBlocks ? 'alert-danger' : 'alert-warning'">
        <span class="flex-grow-1">
          Kimlikteki ad (<b>{{ ocrResult.firstName }} {{ ocrResult.lastName }}</b>) seçili müşteriyle
          (<b>{{ customerCard?.name }}</b>) uyuşmuyor.
          <ng-container *ngIf="ocrNameMismatchBlocks; else nameUnverifiedTpl">Doğru müşteriyi seçin ya da kartı güncelleyin — bu hâlde kayıt yapılamaz.</ng-container>
          <ng-template #nameUnverifiedTpl>Ad kimlikten tam doğrulanamadı; doğru müşteri seçildiğini kontrol edin.</ng-template>
        </span>
        <button type="button" class="btn btn-sm btn-link p-0" (click)="openCustomerCard()">
          <i class="mdi mdi-open-in-new me-1"></i>Müşteri Kartı
        </button>
        <button type="button" class="btn btn-sm btn-link p-0" (click)="refreshCustomerCard()">
          <i class="mdi mdi-refresh me-1"></i>Yenile
        </button>
      </div>
      <div class="alert alert-warning py-1 px-2 small mt-2 mb-0" *ngIf="ocrExpired">
        <i class="mdi mdi-alert-outline me-1"></i>Kartın süresi {{ ocrResult.expiryDate | date: 'dd.MM.yyyy' }} tarihinde dolmuş —
        kimlik tespiti geçerli belgeyle yapılmalıdır (kayıt engellenmez).
      </div>
      <div class="kyc-hint text-warning mt-1" *ngFor="let w of ocrResult.warnings">
        <i class="mdi mdi-alert-circle-outline me-1"></i>{{ w }}
      </div>
      <div class="kyc-hint mt-1" *ngFor="let k of ocrKeptManual">
        <i class="mdi mdi-information-outline me-1 text-warning"></i>{{ k.label }}: formdaki <b>{{ k.current }}</b> korundu,
        kimlikte <b>{{ k.value }}</b> yazıyor.
        <a href="javascript:void(0)" (click)="useOcrValue(k.field)">Kimliktekini kullan</a>
      </div>
      <div class="kyc-hint mt-1" *ngIf="ocrCustomerNotice">
        <i class="mdi mdi-account-search-outline me-1"></i>{{ ocrCustomerNotice }}
      </div>
    </ng-container>
    <div class="kyc-hint mt-1" *ngIf="ocrCustomerSearching">
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>Kimlikteki TCKN ile kayıtlı müşteri aranıyor…
    </div>
  </div>

  <!-- ── 2. Müşteri ──────────────────────────────────────────────────────────────────────────────── -->
  <div class="kyc-section"><i class="mdi mdi-account-outline"></i>{{ embedded ? 'Kişi Türü' : 'Müşteri' }}</div>
  <div class="row g-2 mb-2">
    <div [ngClass]="!isEdit && !embedded ? 'col-md-6' : 'col-12'">
      <div class="btn-group btn-group-sm w-100" role="group">
        <button type="button" class="btn" [class.btn-primary]="!isCompany" [class.btn-outline-primary]="isCompany"
          (click)="setPersonType(CustomerType.Person)"><i class="mdi mdi-account me-1"></i>Gerçek Kişi</button>
        <button type="button" class="btn" [class.btn-primary]="isCompany" [class.btn-outline-primary]="!isCompany"
          (click)="setPersonType(CustomerType.Company)"><i class="mdi mdi-domain me-1"></i>Tüzel Kişi</button>
      </div>
    </div>
    <div class="col-md-6" *ngIf="!isEdit && !embedded">
      <div class="btn-group btn-group-sm w-100" role="group">
        <button type="button" class="btn" [class.btn-secondary]="!isNewCustomer" [class.btn-outline-secondary]="isNewCustomer"
          (click)="setCustomerMode(false)">Kayıtlı Müşteri</button>
        <button type="button" class="btn" [class.btn-secondary]="isNewCustomer" [class.btn-outline-secondary]="!isNewCustomer"
          (click)="setCustomerMode(true)">Yeni Müşteri</button>
      </div>
    </div>
  </div>

  <div class="mb-2" *ngIf="isEdit">
    <input type="text" class="form-control form-control-sm" [value]="request.customerName" disabled>
    <div class="kyc-hint mt-1">Müşteri bağlantısı değiştirilemez; farklı müşteriyse yeni kayıt açın.</div>
  </div>

  <div class="mb-2" *ngIf="!isEdit && !embedded && !isNewCustomer">
    <ng-select [items]="customer$ | async" [typeahead]="customerInput$" [loading]="customersLoading"
      bindLabel="text" bindValue="value" [(ngModel)]="request.customerId" name="customerId"
      (ngModelChange)="onCustomerSelected($event)"
      placeholder="Müşteri arayın…" notFoundText="Kayıt bulunamadı!">
    </ng-select>
  </div>

  <div class="kyc-hint mb-2" *ngIf="!isEdit && !embedded && isNewCustomer && isCompany">
    Yeni müşteri kartı aşağıdaki şirket bilgileriyle (tüzel kişi olarak) açılır.
  </div>

  <!-- Seri no / TCKN / son geçerlilik — gerçek kişide kimlik bilgilerinde, tüzel kişide yetkili bölümünde. -->
  <ng-template #documentFieldsTpl>
    <div class="col-md-4" *ngIf="showTcknField">
      <label class="form-label">{{ isCompany ? 'Yetkilinin T.C. Kimlik No' : 'T.C. Kimlik No' }}{{ isTckn ? ' *' : '' }}<span class="ocr-tag" *ngIf="ocrFilled('tckn')">OCR</span></label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="request.tckn" name="tckn" maxlength="11"
        inputmode="numeric" [placeholder]="isTckn ? '11 hane' : 'Türk vatandaşıysa'" [class.is-invalid]="tcknInvalid">
      <div class="invalid-feedback">Geçersiz T.C. kimlik numarası.</div>
      <div class="kyc-hint text-warning" *ngIf="tcknDiffersFromCard">
        Kartta farklı: {{ customerCard?.tckn }} — kaydederken sorulur.
      </div>
    </div>
    <div class="col-6 col-md-4">
      <label class="form-label">{{ documentNumberLabel }}<span class="ocr-tag" *ngIf="ocrFilled('documentNumber')">OCR</span></label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="request.documentNumber" name="documentNumber"
        [placeholder]="isTckn ? 'A12B34567' : isPassport ? 'U12345678' : ''" maxlength="50">
      <div class="kyc-hint" *ngIf="legacySerialMissing && !request.documentNumber">Eski kayıt — seri no girilebilir.</div>
      <div class="kyc-hint text-warning" *ngIf="serialFormatUnexpected">Biçim beklenenden farklı (ör. A12B34567).</div>
    </div>
    <div class="col-6 col-md-4">
      <label class="form-label">Son Geçerlilik<span class="ocr-tag" *ngIf="ocrFilled('documentExpiryDate')">OCR</span></label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="request.documentExpiryDate" name="documentExpiryDate"
        [class.border-warning]="documentExpired">
      <div class="kyc-hint text-warning" *ngIf="documentExpired"><i class="mdi mdi-alert-outline me-1"></i>Süresi dolmuş.</div>
    </div>
  </ng-template>

  <!-- ── 3a. Gerçek kişi: kimlik bilgileri (Tedbirler Yönetmeliği Md.6) ─────────────────────────────── -->
  <ng-container *ngIf="!isCompany">
    <div class="kyc-section">
      <i class="mdi mdi-badge-account-horizontal-outline"></i>Kimlik Bilgileri
      <span class="kyc-section-aside">Tedbirler Yönetmeliği Md.6</span>
    </div>
    <div class="row g-2 mb-2" *ngIf="!isEdit && !embedded && isNewCustomer">
      <div class="col-6">
        <label class="form-label">Ad *<span class="ocr-tag" *ngIf="ocrFilled('firstName')">OCR</span></label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="newCustomer.firstName" name="newCustomerFirstName">
      </div>
      <div class="col-6">
        <label class="form-label">Soyad *<span class="ocr-tag" *ngIf="ocrFilled('lastName')">OCR</span></label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="newCustomer.lastName" name="newCustomerLastName">
      </div>
    </div>
    <div class="row g-2 mb-2">
      <ng-container *ngTemplateOutlet="documentFieldsTpl"></ng-container>
    </div>
    <div class="row g-2 mb-2">
      <div class="col-6 col-md-4">
        <label class="form-label">Doğum Tarihi<span class="ocr-tag" *ngIf="ocrFilled('birthDate')">OCR</span></label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="request.birthDate" name="birthDate">
      </div>
      <div class="col-6 col-md-4">
        <label class="form-label">Doğum Yeri</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.birthPlace" name="birthPlace">
      </div>
      <div class="col-6 col-md-4">
        <label class="form-label">Uyruğu<span class="ocr-tag" *ngIf="ocrFilled('nationality')">OCR</span></label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.nationality" name="nationality">
      </div>
    </div>
    <div class="row g-2 mb-2">
      <div class="col-6 col-md-4">
        <label class="form-label">Meslek</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.occupation" name="occupation">
      </div>
      <ng-container *ngIf="!isEdit && !embedded && isNewCustomer">
        <div class="col-6 col-md-4">
          <label class="form-label">Telefon</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="newCustomer.phone" name="newCustomerPhone">
        </div>
        <div class="col-6 col-md-4">
          <label class="form-label">E-posta</label>
          <input type="email" class="form-control form-control-sm" [(ngModel)]="newCustomer.email" name="newCustomerEmail">
        </div>
      </ng-container>
    </div>
    <div class="row g-2 mb-2" *ngIf="!isEdit && !embedded && isNewCustomer">
      <div class="col-6 col-md-3">
        <label class="form-label">İl</label>
        <select class="form-select form-select-sm" [(ngModel)]="newCustomer.city" name="newCustomerCity" (ngModelChange)="onProvinceChange()">
          <option [ngValue]="undefined">İl seçin</option>
          <option *ngFor="let p of provinces" [ngValue]="p.il">{{ p.il }}</option>
        </select>
      </div>
      <div class="col-6 col-md-3">
        <label class="form-label">İlçe</label>
        <select class="form-select form-select-sm" [(ngModel)]="newCustomer.district" name="newCustomerDistrict" [disabled]="!newCustomer.city">
          <option [ngValue]="undefined">{{ newCustomer.city ? 'İlçe seçin' : 'Önce il' }}</option>
          <option *ngFor="let d of districtOptions" [ngValue]="d">{{ d }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">Açık Adres</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="newCustomer.shortAddress" name="newCustomerShortAddress">
      </div>
    </div>
    <div class="kyc-hint" *ngIf="(isTckn || (isPassport && request.tckn)) && !tcknInvalid && !tcknDiffersFromCard">
      <i class="mdi mdi-information-outline me-1"></i>{{ usesCustomerCard ? 'Müşteri kartında TCKN yoksa kayıtla birlikte karta da yazılır.' : 'Yeni müşteri kartı bu TCKN ile açılır.' }}
    </div>
  </ng-container>

  <!-- ── 3b. Tüzel kişi: şirket + temsile yetkili kişi ────────────────────────────────────────────── -->
  <ng-container *ngIf="isCompany">
    <div class="kyc-section">
      <i class="mdi mdi-domain"></i>Şirket Bilgileri
      <span class="kyc-section-aside" *ngIf="usesCustomerCard">Müşteri kartından alınır</span>
    </div>

    <!-- Kayıtlı müşteri / düzenleme: şirket bilgileri müşteri kartından (backend kopyalar). -->
    <ng-container *ngIf="usesCustomerCard">
      <div *ngIf="customerCardLoading" class="text-center py-2"><span class="spinner-border spinner-border-sm" role="status"></span></div>
      <div *ngIf="!customerCardLoading && !customerCard" class="kyc-hint mb-2">Müşteri seçildiğinde kart bilgileri burada görünür.</div>
      <ng-container *ngIf="!customerCardLoading && customerCard">
        <div class="alert alert-warning py-1 px-2 small mb-2" *ngIf="customerCard.customerType !== CustomerType.Company">
          Seçilen müşteri kartı Gerçek Kişi olarak tanımlı.
        </div>
        <div class="alert alert-danger d-flex flex-wrap align-items-center gap-2 py-1 px-2 small mb-2" *ngIf="customerCardMissing.length">
          <span class="flex-grow-1">Müşteri kartında eksik: {{ customerCardMissing.join(', ') }}. Önce kartı güncelleyin.</span>
          <button type="button" class="btn btn-sm btn-link p-0" (click)="openCustomerCard()">
            <i class="mdi mdi-open-in-new me-1"></i>Müşteri Kartı
          </button>
          <button type="button" class="btn btn-sm btn-link p-0" (click)="refreshCustomerCard()">
            <i class="mdi mdi-refresh me-1"></i>Yenile
          </button>
        </div>
        <dl class="row g-0 small mb-2">
          <dt class="col-sm-2 text-muted fw-normal">Unvan</dt>
          <dd class="col-sm-4 mb-1">{{ customerCard.name || '—' }}</dd>
          <dt class="col-sm-2 text-muted fw-normal">VKN</dt>
          <dd class="col-sm-4 mb-1">{{ customerCard.taxNumber || '—' }}</dd>
          <dt class="col-sm-2 text-muted fw-normal">Telefon</dt>
          <dd class="col-sm-4 mb-1">{{ customerCard.phone || '—' }}</dd>
          <dt class="col-sm-2 text-muted fw-normal">E-posta</dt>
          <dd class="col-sm-4 mb-1">{{ customerCard.email || '—' }}</dd>
          <dt class="col-sm-2 text-muted fw-normal">Adres</dt>
          <dd class="col-sm-10 mb-0">
            {{ customerCard.shortAddress || '—' }}
            <span *ngIf="customerCard.district || customerCard.city" class="text-muted">
              ({{ customerCard.district }}<span *ngIf="customerCard.district && customerCard.city"> / </span>{{ customerCard.city }})
            </span>
          </dd>
        </dl>
      </ng-container>
    </ng-container>

    <!-- Yeni müşteri: kart bu bilgilerle (tüzel kişi olarak) açılır. -->
    <ng-container *ngIf="!usesCustomerCard">
      <div class="row g-2 mb-2">
        <div class="col-md-8">
          <label class="form-label">Şirket Unvanı *</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="request.companyTitle" name="companyTitle">
        </div>
        <div class="col-md-4">
          <label class="form-label">Vergi Kimlik No *</label>
          <input type="text" class="form-control form-control-sm" maxlength="20" [(ngModel)]="request.taxNumber" name="taxNumber">
        </div>
      </div>
      <div class="row g-2 mb-2">
        <div class="col-md-6">
          <label class="form-label">Telefon *</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="request.companyPhone" name="companyPhone">
        </div>
        <div class="col-md-6">
          <label class="form-label">E-posta</label>
          <input type="email" class="form-control form-control-sm" [(ngModel)]="request.companyEmail" name="companyEmail">
        </div>
      </div>
      <div class="row g-2 mb-2">
        <div class="col-6 col-md-3">
          <label class="form-label">İl</label>
          <select class="form-select form-select-sm" [(ngModel)]="request.companyCity" name="companyCity" (ngModelChange)="onCompanyProvinceChange()">
            <option [ngValue]="undefined">İl seçin</option>
            <option *ngFor="let p of provinces" [ngValue]="p.il">{{ p.il }}</option>
          </select>
        </div>
        <div class="col-6 col-md-3">
          <label class="form-label">İlçe</label>
          <select class="form-select form-select-sm" [(ngModel)]="request.companyDistrict" name="companyDistrict" [disabled]="!request.companyCity">
            <option [ngValue]="undefined">{{ request.companyCity ? 'İlçe seçin' : 'Önce il' }}</option>
            <option *ngFor="let d of companyDistrictOptions" [ngValue]="d">{{ d }}</option>
          </select>
        </div>
        <div class="col-md-6">
          <label class="form-label">Açık Adres *</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="request.companyAddress" name="companyAddress">
        </div>
      </div>
    </ng-container>

    <!-- Müşteri kartında karşılığı yok — her zaman formda girilir. -->
    <div class="row g-2 mb-2">
      <div class="col-md-4">
        <label class="form-label">Ticaret Sicil No *</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.tradeRegistryNumber" name="tradeRegistryNumber">
      </div>
      <div class="col-md-8">
        <label class="form-label">Faaliyet Konusu *</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.businessActivity" name="businessActivity">
      </div>
    </div>

    <div class="kyc-section"><i class="mdi mdi-account-tie-outline"></i>Yetkili Kişi</div>
    <div class="row g-2 mb-2">
      <div class="col-6 col-md-3">
        <label class="form-label">Ad *<span class="ocr-tag" *ngIf="ocrFilled('firstName')">OCR</span></label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.representativeFirstName" name="representativeFirstName">
      </div>
      <div class="col-6 col-md-3">
        <label class="form-label">Soyad *<span class="ocr-tag" *ngIf="ocrFilled('lastName')">OCR</span></label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.representativeLastName" name="representativeLastName">
      </div>
      <div class="col-6 col-md-3">
        <label class="form-label">Doğum Tarihi *<span class="ocr-tag" *ngIf="ocrFilled('birthDate')">OCR</span></label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="request.birthDate" name="representativeBirthDate">
      </div>
      <div class="col-6 col-md-3">
        <label class="form-label">Uyruğu *<span class="ocr-tag" *ngIf="ocrFilled('nationality')">OCR</span></label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.nationality" name="representativeNationality">
      </div>
    </div>
    <div class="row g-2 mb-2">
      <ng-container *ngTemplateOutlet="documentFieldsTpl"></ng-container>
    </div>
    <div class="mb-2">
      <label class="form-label">Temsil Yetkileri *</label>
      <textarea class="form-control form-control-sm" rows="2" placeholder="İmza sirkülerindeki yetkinin kapsamı ve süresi"
        [(ngModel)]="request.representationAuthority" name="representationAuthority"></textarea>
    </div>
  </ng-container>

  <!-- ── 4. İşlem ───────────────────────────────────────────────────────────────────────────────── -->
  <ng-container *ngIf="!embedded">
    <div class="kyc-section"><i class="mdi mdi-cash-multiple"></i>İşlem</div>
    <div class="row g-2 mb-2">
      <div class="col-md-4">
        <label class="form-label">İşlem Tutarı (TL)</label>
        <input type="number" class="form-control form-control-sm" min="0" [(ngModel)]="request.transactionAmountTl" name="transactionAmountTl">
      </div>
      <div class="col-md-8">
        <label class="form-label">Not</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="request.note" name="note">
      </div>
    </div>
    <div class="mb-2" *ngIf="purposeRequired">
      <label class="form-label">İşlem Mahiyeti Beyanı *</label>
      <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="request.transactionPurposeDescription"
        name="transactionPurposeDescription" minlength="20"
        [placeholder]="(purposeBandMinTl | number) + '–' + (purposeBandMaxTl | number) + ' TL bandında en az ' + purposeMinLength + ' karakterlik açıklama zorunludur.'"></textarea>
      <div class="kyc-hint text-end">{{ (request.transactionPurposeDescription || '').trim().length }} / {{ purposeMinLength }}</div>
    </div>
  </ng-container>

  <!-- ── 5. Eklenecek belgeler ──────────────────────────────────────────────────────────────────── -->
  <div class="kyc-section">
    <i class="mdi mdi-paperclip"></i>Eklenecek Belgeler
    <span class="kyc-section-aside">PDF, JPG, PNG · belge başına en fazla 10 MB</span>
  </div>
  <div class="kyc-hint mb-1" *ngIf="isCompany">Ticaret sicil gazetesi, imza sirküleri, vergi levhası gibi gerekli belgeleri ekleyin.</div>
  <ul class="list-group attachment-list mb-2" *ngIf="existingAttachments.length || pendingAttachments.length || identityUploadItems.length">
    <li class="list-group-item d-flex align-items-center gap-2" *ngFor="let d of identityUploadItems; trackBy: trackIdentityUpload">
      <i class="mdi mdi-card-account-details-outline text-primary"></i>
      <span class="text-truncate flex-grow-1">{{ d.label }}: {{ d.file.name }}</span>
      <span class="text-muted text-nowrap">{{ formatFileSize(d.file.size) }} · kayıtta yüklenecek</span>
      <button type="button" class="btn btn-sm btn-link text-muted p-0" title="Listeden çıkar"
        (click)="removeIdentityFile(d.side)"><i class="mdi mdi-close"></i></button>
    </li>
    <li class="list-group-item d-flex align-items-center gap-2" *ngFor="let a of existingAttachments">
      <i class="mdi mdi-file-document-outline"></i>
      <span class="text-truncate flex-grow-1">{{ a.originalFileName }}</span>
      <span class="text-muted text-nowrap">{{ formatFileSize(a.fileSize) }}</span>
      <button type="button" class="btn btn-sm btn-link text-danger p-0" title="Sil" [disabled]="deletingAttachmentId === a.id"
        (click)="deleteExistingAttachment(a)"><i class="mdi mdi-trash-can-outline"></i></button>
    </li>
    <li class="list-group-item d-flex align-items-center gap-2" *ngFor="let f of pendingAttachments; let i = index">
      <i class="mdi mdi-file-upload-outline"></i>
      <span class="text-truncate flex-grow-1">{{ f.name }}</span>
      <span class="text-muted text-nowrap">{{ formatFileSize(f.size) }} · kayıtta yüklenecek</span>
      <button type="button" class="btn btn-sm btn-link text-muted p-0" title="Listeden çıkar"
        (click)="removePendingAttachment(i)"><i class="mdi mdi-close"></i></button>
    </li>
  </ul>
  <label class="file-pick mb-2">
    <input type="file" class="d-none" multiple [accept]="attachmentAccept" (change)="onAttachmentsSelected($event)">
    <i class="mdi mdi-plus-circle-outline"></i>
    <span class="file-pick-name">Belge ekle{{ isCompany ? '' : ' (isteğe bağlı)' }}</span>
  </label>

  <!-- ── 6. İmza ────────────────────────────────────────────────────────────────────────────────── -->
  <ng-container *ngIf="!embedded">
    <div class="kyc-section"><i class="mdi mdi-draw"></i>İmza</div>
    <app-signature-pad
      [disabled]="saving"
      [existingSvg]="existingSignatureSvg"
      [(existingRemoved)]="existingSignatureRemoved"
      (valueChange)="signature = $event"
      description="Müşteri (tüzel kişide yetkilisi) fareyle, parmakla ya da kalemle imza atar; imza basılan formun imza kutusuna da basılır.">
    </app-signature-pad>
  </ng-container>
</div>

<ng-template #loadingTpl>
  <div class="modal-body text-center py-5">
    <span class="spinner-border" role="status"></span>
  </div>
</ng-template>

<div class="modal-footer py-2" *ngIf="!embedded">
  <button type="button" class="btn btn-sm btn-light" (click)="activeModal.dismiss()">Vazgeç</button>
  <button type="button" class="btn btn-sm btn-outline-warning" *ngIf="allowSkip" [disabled]="saving || loading"
    (click)="skip()">Daha Sonra Gir</button>
  <button type="button" class="btn btn-sm btn-primary px-3" [disabled]="saving || loading || ocrReading" (click)="save()">
    <span *ngIf="saving" class="spinner-border spinner-border-sm me-1" role="status"></span>
    {{ isEdit ? 'Güncelle' : 'Kaydet' }}
  </button>
</div>
